import React from "react";
import Image from "components/common/Image";
import gs from "gstyles";

const Footer = () => {
  return (
    <div className="relative w-full">
      <div className="fixed bottom-[-314px] left-0 w-full h-[460px] bg-white z-[-1]"></div>
      <footer className="relative w-full flex flex-col bg-white py-6 lg:py-4 ">
        <div className="container mx-auto px-6 flex flex-col lg:flex-row items-center lg:justify-between gap-4 lg:gap-0 flex-1">
          <div className="flex-shrink-0 mb-2">
            {gs.icons({ name: "logo-color", width: 140 })}
          </div>
          <div className="flex-1 lg:mx-8 text-sm text-gray-700 text-center lg:text-left">
            <p className="font-semibold mb-2">
              Bản quyền của Công ty CP Lookme
            </p>
            <p className="!mb-0">
              Giấy chứng nhận Đăng ký Kinh doanh số 0315074848 do Sở KH&ĐT TP
              HCM cấp ngày 28/05/2018.
            </p>
            <p className="!mb-0 lg:mb-1">
              Địa chỉ: 481/14 Đường số 10, Phường Thống Tây Hội, TP HCM.
            </p>
          </div>
          <div className="flex-shrink-0 w-full max-w-[180px] lg:max-w-[230px]">
            <Image
              isRelative={true}
              src="/bct.png"
              alt="Lookme đã đăng ký bộ công thương"
              wrapClassName="relative w-full aspect-[310/116] rounded-md object-contain"
            />
          </div>
        </div>
        <div className="container mx-auto px-6 pt-2">
          <p className="text-center text-sm text-gray-600 !mb-0">
            Copyright © 2025 Lookme. All rights reserved
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
